export const quest_widget = {
	QUEST_WIDGET_TITLE: {
		value: 'THE LOST SCROLL',
		config: {
			fill: ['#92CF25', '#225A0F'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	QUEST_WIDGET_SUBTITLE: {
		value: 'Refreshes in',
		config: {
			fill: '#CFDBB5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	QUEST_WIDGET_TIMER: {
		value: '',
		config: {
			fill: '#CFDBB5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	}
};
